'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromizeTab = function (_React$Component) {
    _inherits(PromizeTab, _React$Component);

    function PromizeTab() {
        _classCallCheck(this, PromizeTab);

        return _possibleConstructorReturn(this, (PromizeTab.__proto__ || Object.getPrototypeOf(PromizeTab)).apply(this, arguments));
    }

    _createClass(PromizeTab, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            var pzCustomizer = this.props.pzCustomizer;

            var tabs = this.props.pzCustomizer.tabs ? this.props.pzCustomizer.tabs : {};
            Object.keys(tabs).length > 0 && Object.keys(tabs).map(function (tab, index) {
                fetch(_this2.props.pzApiUrl + 'getSubTabsWithTabId/?id=' + tab).then(function (res) {
                    return res.json();
                }).then(function (response) {
                    response.subtabs.length > 0 && response.subtabs.map(function (sub_tab, tab_idex) {
                        if (!pzCustomizer.subtabs[tab]) {
                            pzCustomizer.subtabs[tab] = {};
                        }
                        pzCustomizer.subtabs[tab][sub_tab.child_tab_id] = sub_tab;
                    });
                    _this2.props.HomeComponent.setState({ pzCustomizer: pzCustomizer });
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var tabs = this.props.pzCustomizer.tabs ? this.props.pzCustomizer.tabs : {};
            return React.createElement(
                React.Fragment,
                null,
                Object.keys(tabs).length > 0 && React.createElement(PZTab, _extends({ pzTabs: tabs }, this.props, { pzOpenPopup: this.props.HomeComponent.pzOpenPopup, pzClosePopup: this.props.HomeComponent.pzClosePopup, popup: this.props.popup, applyType: this.props.applyType, pzSelectView: this.props.HomeComponent.pzSelectView }))
            );
        }
    }]);

    return PromizeTab;
}(React.Component);